"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupNativeMockRoutes = exports.setupWebMockRoutes = void 0;
var msw_1 = require("msw");
var native_1 = require("msw/native");
var orchestration_1 = require("./handlers/orchestration");
__exportStar(require("./fixtures"), exports);
__exportStar(require("./routes"), exports);
__exportStar(require("./mock-states"), exports);
function getAllHandlers(state) {
    return __spreadArray([], (0, orchestration_1.getOrchestrationHandlers)(state), true);
}
function setupWebMockRoutes(state) {
    console.log("Mock state: ".concat(state));
    return msw_1.setupWorker.apply(void 0, getAllHandlers(state));
}
exports.setupWebMockRoutes = setupWebMockRoutes;
function setupNativeMockRoutes(state) {
    console.log("Mock state: ".concat(state));
    return native_1.setupServer.apply(void 0, getAllHandlers(state));
}
exports.setupNativeMockRoutes = setupNativeMockRoutes;
